<template>
  <div id="publishing-journal-websiteer-policy-add">
    <ipub-model
      :title="params.id ? 'Edit Journal Sub-Menu' : 'Add Journal Sub-Menu'"
      width="900px"
      :visable="isVisable"
      @confirm="confirm"
      @cancel="cancel"
    >
      <ipub-form ref="publisher-policy-add-form" :model="params" :rules="rules">
        <!--        菜单名称-->
        <ipub-form-item prop="name" label="Journal Sub-Menu Title">
          <ipub-input
            placeholder="Journal Sub-Menu Title"
            v-model.trim="params.name"
          />
        </ipub-form-item>

        <!--        菜单类型-->
        <ipub-form-item prop="type" label="Menu Type">
          <ipub-select
            placeholder="Menu Type"
            optionKey="id"
            v-model="params.type"
          >
            <ipub-select-option
              :value="menu.value"
              v-for="(menu, index) in menuTypes"
              :key="index"
              >{{ menu.label }}
            </ipub-select-option>
          </ipub-select>
        </ipub-form-item>



        <!--        选择父级菜单-->
        <ipub-form-item prop="parentId" label="Journal Menu Belongs To">
          <ipub-select
            placeholder="Journal Menu Belongs To"
            :options="tree"
            :optionsHeight="400"
            :tree="true"
            optionKey="id"
            v-model="params.parentId"
          />
        </ipub-form-item>



        <!--        自定义页面-->
        <ipub-form-item
          prop="code"
          label="Code"
          v-if="params.type === 'CUSTOMIZE' || params.type === 'SYSTEM'"
        >
          <!--          自定义页面-->
          <template v-if="params.type === 'CUSTOMIZE'">
            <ipub-input placeholder="Enter code here" v-model="params.code" />
          </template>
          <!--          系统页面-->
          <template v-if="params.type === 'SYSTEM'">
            <ipub-select
              placeholder="System Menu"
              optionKey="id"
              v-model="params.code"
            >
              <ipub-select-option
                :value="menu.value"
                v-for="(menu, index) in systemMenus"
                :key="index"
                >{{ menu.label }}
              </ipub-select-option>
            </ipub-select>
          </template>
        </ipub-form-item>


        <!--        菜单类别-->
        <ipub-form-item prop="category"
                        label="Menu Category"
                        v-if="params.type === 'CUSTOMIZE'"
        >
          <ipub-select
            placeholder="Menu Category"
            optionKey="id"
            v-model="params.category"
          >
            <ipub-select-option
              :value="category.value"
              v-for="(category, index) in categories"
              :key="index"
            >{{ category.label }}
            </ipub-select-option>
          </ipub-select>
        </ipub-form-item>

        <!--        如果是自定义页面,填写页面内容-->
        <ipub-form-item
          prop="content"
          label="Content"
          v-if="params.type === 'CUSTOMIZE' || params.type === 'SYSTEM' || params.type === 'SYSTEM_EDIT'"
        >
          <ipub-editor
            :height="400"
            placeholder="Enter policy details here"
            v-model="params.content"
          />
        </ipub-form-item>

        <!--        如果是外部链接,填写链接-->
        <ipub-form-item
          prop="externalLink"
          label="External Link"
          v-if="params.type === 'LINK'"
        >
          <ipub-input
            placeholder="Enter external link here"
            v-model="params.externalLink"
          />
        </ipub-form-item>

        <!--        排序-->
        <ipub-form-item prop="sort" label="Sort">
          <ipub-input placeholder="Enter sort" v-model.number="params.sort" />
        </ipub-form-item>
      </ipub-form>
      <div slot="footer">
        <ipub-button
          plain
          type="primary"
          :style="{ minWidth: '150px' }"
          @click="cancel"
          >Cancel
        </ipub-button>
        <ipub-button
          type="primary"
          :style="{ minWidth: '150px' }"
          @click="confirm"
          >Publish
        </ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import jmenu from '../../../../api/jmenu'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    tree: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      params: {},
      rules: {},
      categories:[
        {
          label: 'about',
          value: 'ABOUT',
        },
        {
          label: 'info',
          value: 'INFO',
        },
        {
          label: 'articles',
          value: 'ARTICLES',
        },
      ],
      menuTypes: [
        {
          label: 'System',
          value: 'SYSTEM',
        },
        {
          label: 'Customize',
          value: 'CUSTOMIZE',
        },
        {
          label: 'Link',
          value: 'LINK',
        },
        {
          label: 'No Content',
          value: 'NO_CONTENT',
        },
      ],
      systemMenus: [
        {
          label: 'Home',
          value: 'home',
        },
        {
          label: 'Article Processing Charge',
          value: 'apc',
        },
        {
          label: 'Editorial Process',
          value: 'editorial_process',
        },
        {
          label: 'Instructions for Authors',
          value: 'instructions',
        },
        {
          label: 'Search',
          value: 'search',
        },
        {
          label: 'All Issues',
          value: 'volumes_and_issues',
        },
        {
          label: 'Topics',
          value: 'topics',
        },
        {
          label: 'Special Issues',
          value: 'special_issues',
        },
        {
          label: 'Apply Special Issues',
          value: 'apply_special_issues',
        },
        {
          label: 'Sections',
          value: 'section',
        },
        {
          label: 'Editorial Office',
          value: 'editorial_office',
        },
        {
          label: 'Current Issue',
          value: 'current_issue',
        },
        {
          label: 'Forthcoming Issue',
          value: 'forthcoming_issue',
        },
        {
          label: 'Reviewer Board',
          value: 'reviewer_board',
        },
        {
          label: 'Editorial Board',
          value: 'editorial_board',
        },
        {
          label: 'Apply for Editorial Board',
          value: 'apply_editorial_board',
        },
        {
          label: 'Conferences',
          value: 'conference',
        },
        {
          label: 'Announcements',
          value: 'announcement',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      domain: 'getDomain',
    }),
  },
  watch: {
    isVisable(val) {
      if (!val) {
        this.params = {}
      }
    },
  },
  mounted() {
    this.getRules()
  },
  methods: {
    setParentId(id) {
      this.params.parentId = id
    },
    async getQuery(id) {
      this.params = await jmenu.query(id)
    },
    async confirm() {
      const flag = this.$refs['publisher-policy-add-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          journalId: this.journalId,
          code: this.params.type
            ? this.params.code
            : this.params.name
                .toLowerCase()
                .replace(' & ', '_')
                .replace(/\s/g, '_'),
        })

        if (data.type === 'CUSTOMIZE' || data.type === 'SYSTEM') {
          if (!data.code){
            this.$message.error({
              title: 'Error',
              content: 'Please enter menu code',
            })
            return
          }
          if (data.code.includes('/')){
            this.$message.error({
              title: 'Error',
              content: 'Menu code cannot contain a slash (/) character',
            })
            return
          }

          if (data.code.length >= 512){
            this.$message.error({
              title: 'Error',
              content: 'Policy title: Maxium 512 characters',
            })
            return
          }
        }

        if (this.params.id) {
          await jmenu.edit(this.params.id, data)
          this.$message.success({
            title: 'Success',
            content: 'This Department has been Created!',
          })
        } else {
          await jmenu.add(data)
          this.$message.success({
            title: 'Success',
            content: 'This Department has been saved!',
          })
        }
        this.$emit('confirm', data)
      }
    },
    preview() {},
    cancel() {
      this.$emit('cancel')
    },
    getRules() {
      this.rules = {
        name: [
          {
            required: true,
            message: 'Policy Title' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        // parentId: [
        //   {
        //     required: true,
        //     message:
        //       'Policy Belongs To' +
        //       this.LANGUAGE[this.language].noEmpty
        //   }
        // ],
        // content: [
        //   {
        //     required: true,
        //     message:
        //       'Content' +
        //       this.LANGUAGE[this.language].noEmpty
        //   }
        // ]
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
